export default {
      id: "lignes-usage",
      viewBox: "0 0 3000 100",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#lignes-usage",
      toString: function () {
        return this.url;
      }
    }